import gql from 'graphql-tag';

export default gql`
  query occupations(
    $projectId: Int!
    $startDate: String!
    $workState: String!
    $hireState: String!
    $workCity: String
    $currency: String
    $union: String!
    $season: Int
  ) {
    occupations(
      projectId: $projectId
      startDate: $startDate
      workState: $workState
      hireState: $hireState
      workCity: $workCity
      currency: $currency
      union: $union
      season: $season
    ) {
      code
      description
    }
  }
`;
